import gql from "graphql-tag";

export const EDIT_COMMENT = gql`
  mutation ($input: editCommentInput) {
    editComment(input: $input) {
      _id
      content
      created_at
      edited
      created_by {
        _id
        full_name
        email
        avatar
      }
    }
  }
`;
